module.exports = __webpack_public_path__ + "static/media/typeIcon.e36ea867.svg";